import { useState } from "react";
import type { Strings } from "../i18n/strings";
import { hotlineFor } from "../lib/crisis";
import type { Lang } from "../lib/types";

interface Props {
  t: Strings;
  lang: Lang;
  onClose: () => void;
}

// ⑩ 위기 폴백 (crisis): 농담·점수·광고 전부 중단. "행동 금지"의 유일한 예외.
// 멈춤 한 줄 + 핫라인(1순위 굵게, 24시간·무료) + "다른 창구" 접기.
export default function Crisis({ t, lang, onClose }: Props) {
  const hotline = hotlineFor(lang);
  const [open, setOpen] = useState(false);

  return (
    <div className="screen crisis">
      <div className="rep-header">
        <button className="navbtn" onClick={onClose}>
          ✕ {t.close}
        </button>
      </div>
      <div className="crisis-body">
        {t.crStop.split("\n").map((line, i) => (
          <p key={i} className="crisis-stop">
            {line}
          </p>
        ))}
        <div className="hotline-box">
          <div className="hotline-primary">{hotline.primary}</div>
          <div className="hotline-note">{t.crNote}</div>
          {open ? (
            <ul className="hotline-more">
              {hotline.more.map((m, i) => (
                <li key={i}>
                  {typeof m === "string" ? (
                    m
                  ) : (
                    <a href={m.url} target="_blank" rel="noopener noreferrer">
                      {m.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          ) : (
            <button className="hotline-toggle" onClick={() => setOpen(true)}>
              {t.crMore} ›
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
